<div class="flex flex-col profiles">
  <div class="flex flex-row">
    <div class="flex flex-col gap-[5px] flex-[1_1_100%] column-content">
      <div class="flex flex-row flex-[1_1_100%]">
        <div class="flex flex-col flex-[1_1_100%]">
          <mat-card  class="profile-card ask mat-elevation-z0" matRipple (click)="selectProfile(currentProfile.uid)">
            <mat-card-header>
              <div mat-card-avatar class="header-image mat-elevation-z2"></div>
              <mat-card-title>{{currentProfile.first_name + ' ' + currentProfile.last_name}}</mat-card-title>
              <mat-card-subtitle>{{currentProfile.username}}</mat-card-subtitle>
            </mat-card-header>
          </mat-card>
          <div class="flex flex-row justify-start items-center">
            <button mat-raised-button color="primary" class="settings-btn" (click)="goToSettings()">{{'ACCOUNT_SETTINGS' | translate}}</button>
          </div>
          <mat-divider></mat-divider>
        </div>
      </div>
      <div class="flex flex-row item-container flex-[1_1_100%]">
        <div class="flex flex-col flex-[1_1_100%]">
          @for (item of recentStaff; track item) {
            <mat-card  class="profile-card ask mat-elevation-z0" matRipple (click)="selectProfile(item.uid)">
              <mat-card-header>
                <div mat-card-avatar class="header-image mat-elevation-z2"></div>
                <mat-card-title>{{item.account0.first_name + ' ' + item.account0.last_name}}</mat-card-title>
                <mat-card-subtitle>{{item.account0.username}}</mat-card-subtitle>
                <mat-card-subtitle><i>{{'signed out'}}</i></mat-card-subtitle>
              </mat-card-header>
            </mat-card>
            <mat-divider></mat-divider>
          }
        </div>
      </div>
      <form class="flex flex-row justify-center items-center pin-form" #pinCode="ngForm">
        <mat-form-field appearance="fill">
          <mat-label>{{'Pin code' | translate}}</mat-label>
          <input matInput [type]="type" [formControl]="pinCodeCtrl" name="pinCode" autocomplete="off" (keydown.enter)="findCode()">
          @if (pinCodeCtrl.valid) {
            <mat-icon matSuffix class="ask" (click)="toggleVisiblity($event)">{{icon}}</mat-icon>
          }
          @if (pinCodeCtrl.hasError('notExist')) {
            <mat-icon color='warn' matSuffix>report</mat-icon>
          }
          <mat-error>
            {{'Invalid Pin Code' | translate}}
          </mat-error>
        </mat-form-field>
        <button mat-icon-button color="primary" (click)="findCode()" class="find-btn">
          <mat-icon>done_outline</mat-icon>
        </button>
      </form>
    </div>
  </div>
</div>
